import loginInit from "../js/login/main";

document.addEventListener("DOMContentLoaded", loginInit);